import { Component, Input } from '@angular/core';
import { TableColumnComponent } from '../table-column/table-column.component';

@Component({
    selector: 'app-column-text',
    templateUrl: './column-text.component.html',
    styleUrls: ['./column-text.component.scss'],
    standalone: false,
})
export class ColumnTextComponent extends TableColumnComponent {
    @Input() placeholder = $localize`Search`;
    @Input() disabled = false;
    @Input() className: string = '';
}
